// Homepage behaviour: the hero slideshow, the rotating announcement bars and
// the hover state on header dropdowns. Everything is opt-in through data
// attributes so a section that does not need it costs nothing.

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Cycles through a set of elements by toggling one class. Used by both the
  // hero and the announcement bars, which differ only in markup.
  function cycle(container, items, delay, activeClass, onChange) {
    if (items.length < 2) return null;

    var current = 0;
    var timer = null;

    function show(next) {
      items[current].classList.remove(activeClass);
      current = (next + items.length) % items.length;
      items[current].classList.add(activeClass);
      if (onChange) onChange(current);
    }

    function start() {
      if (timer || reduceMotion) return;
      timer = window.setInterval(function () {
        show(current + 1);
      }, delay);
    }

    function stop() {
      window.clearInterval(timer);
      timer = null;
    }

    // Pausing on hover and while the tab is hidden keeps a slide from flicking
    // past the moment someone looks back at the page.
    container.addEventListener('mouseenter', stop);
    container.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    start();
    return { show: show, stop: stop, start: start };
  }

  function initHero(root) {
    var slides = root.querySelectorAll('.gf-hero__slide');
    var dots = root.querySelectorAll('[data-gf-hero-dot]');
    var delay = parseInt(root.getAttribute('data-speed'), 10) || 7000;

    function markDot(index) {
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === index);
      }
    }

    var player = root.getAttribute('data-autoplay') === 'true'
      ? cycle(root, slides, delay, 'is-active', markDot)
      : null;

    for (var i = 0; i < dots.length; i++) {
      (function (index) {
        dots[index].addEventListener('click', function () {
          if (player) {
            player.stop();
            player.show(index);
            player.start();
            return;
          }
          for (var j = 0; j < slides.length; j++) {
            slides[j].classList.toggle('is-active', j === index);
          }
          markDot(index);
        });
      })(i);
    }
  }

  // The announcement strip slides sideways rather than fading, and it keeps
  // running while the pointer is over it, which is how the reference bar
  // behaves. The reset off the trailing copy is done on a timer rather than a
  // transitionend, because that event does not fire in a background tab and the
  // strip would be left parked on the copy.
  function initRotator(track) {
    if (track.getAttribute('data-autoplay') !== 'true') return;

    var real = parseInt(track.getAttribute('data-count'), 10) || 0;
    if (real < 2 || reduceMotion) return;

    var delay = parseFloat(track.getAttribute('data-delay')) || 3500;
    var speed = parseFloat(track.getAttribute('data-speed')) || 300;
    var index = 0;

    function advance() {
      index += 1;
      track.style.transition = 'transform ' + speed + 'ms ease';
      track.style.transform = 'translateX(' + index * -100 + '%)';

      if (index === real) {
        window.setTimeout(function () {
          track.style.transition = 'none';
          track.style.transform = 'translateX(0)';
          index = 0;
          // Read a layout value so the jump is committed before the next
          // advance re-enables the transition.
          void track.offsetWidth;
        }, speed + 20);
      }
    }

    window.setInterval(advance, delay);
  }

  // Native details elements only open on click. Opening them on hover as well
  // needs a small delay on the way out, otherwise crossing the gap between the
  // label and the panel snaps it shut.
  function initHoverMenus() {
    var items = document.querySelectorAll('.gf-nav__details[data-gf-hover="true"]');

    for (var i = 0; i < items.length; i++) {
      (function (details) {
        var closeTimer = null;
        var summary = details.querySelector('summary');

        details.addEventListener('mouseenter', function () {
          window.clearTimeout(closeTimer);
          if (window.matchMedia('(hover: hover)').matches) {
            details.open = true;
            if (summary) summary.setAttribute('aria-expanded', 'true');
          }
        });

        details.addEventListener('mouseleave', function () {
          if (!window.matchMedia('(hover: hover)').matches) return;
          closeTimer = window.setTimeout(function () {
            details.open = false;
            if (summary) summary.setAttribute('aria-expanded', 'false');
          }, 120);
        });

        details.addEventListener('toggle', function () {
          if (summary) summary.setAttribute('aria-expanded', String(details.open));
        });
      })(items[i]);
    }
  }

  // Arrow buttons for any scroll-snapping rail. Scrolling by the width of one
  // child keeps the arrows in step with however many cards are in view at the
  // current breakpoint, without hard coding that number twice.
  function initRails() {
    var rails = document.querySelectorAll('[data-gf-rail]');

    for (var i = 0; i < rails.length; i++) {
      (function (rail) {
        var scope = rail.closest('.gf-quotes') || rail.parentNode;
        var prev = scope.querySelector('[data-gf-rail-prev]');
        var next = scope.querySelector('[data-gf-rail-next]');
        if (!prev && !next) return;

        function step(direction) {
          var card = rail.firstElementChild;
          if (!card) return;
          var gap = parseFloat(window.getComputedStyle(rail).columnGap) || 0;
          rail.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
        }

        if (prev) prev.addEventListener('click', function () { step(-1); });
        if (next) next.addEventListener('click', function () { step(1); });
      })(rails[i]);
    }
  }

  // Pagination dots for a scroll-snap rail. Built here rather than in Liquid so
  // the markup stays honest with scripting off, where the rail is just a strip
  // that can be swiped.
  // A closed disclosure keeps its own box the height of the summary, so on a
  // wide screen the footer menus have to actually be open, not just revealed.
  var disclosureState = null;

  function syncDisclosures() {
    var groups = document.querySelectorAll('[data-gf-open-above]');
    if (!groups.length) return;

    var wide = window.innerWidth >= parseInt(groups[0].getAttribute('data-gf-open-above'), 10);
    if (wide === disclosureState) return;
    disclosureState = wide;

    for (var i = 0; i < groups.length; i++) {
      if (wide) groups[i].setAttribute('open', '');
      else groups[i].removeAttribute('open');
    }
  }

  // A rail marked to loop keeps a copy of each end on the opposite side, so the
  // last card shows to the left of the first. Once a swipe settles on a copy
  // the rail steps across to the real card without animating, which reads as
  // carrying on rather than stopping at either end.
  function buildLoop(rail) {
    if (!rail.hasAttribute('data-gf-loop')) return false;
    if (rail.querySelector('[data-gf-clone]')) return true;
    if (rail.scrollWidth <= rail.clientWidth + 4) return false;

    var cards = [].slice.call(rail.children);
    if (cards.length < 2) return false;

    // A whole set is copied to each side rather than a single card. One card
    // is not enough road: a quick flick travels several at once, runs out of
    // rail and stops short, which is what makes a loop feel like it caught on
    // something. With a full set either way there is always somewhere to go,
    // and because the jump back is exactly one set the pictures either side of
    // it are the same ones, so nothing appears to move.
    function copy(card) {
      var clone = card.cloneNode(true);
      clone.setAttribute('data-gf-clone', 'true');
      clone.setAttribute('aria-hidden', 'true');
      return clone;
    }

    for (var i = 0; i < cards.length; i++) rail.appendChild(copy(cards[i]));
    for (var j = cards.length - 1; j >= 0; j--) rail.insertBefore(copy(cards[j]), rail.firstChild);
    return true;
  }

  function realCards(rail) {
    var out = [];
    var kids = rail.children;
    for (var i = 0; i < kids.length; i++) {
      if (!kids[i].hasAttribute('data-gf-clone')) out.push(kids[i]);
    }
    return out;
  }

  function centreOn(rail, card) {
    var left = card.offsetLeft - (rail.clientWidth - card.offsetWidth) / 2;
    rail.scrollTo({ left: left, behavior: 'smooth' });
  }

  // Stepping from a copy to the real card has to be invisible, which means the
  // snapping has to be off while it happens. Left on, the browser treats the
  // new position as a fresh scroll and animates back to the card it had
  // already chosen, which is what makes a rail look like it is fighting the
  // swipe.
  function jumpTo(rail, card) {
    var left = card.offsetLeft - (rail.clientWidth - card.offsetWidth) / 2;
    if (Math.abs(rail.scrollLeft - left) < 1) return;
    var snap = rail.style.scrollSnapType;
    rail.style.scrollSnapType = 'none';
    rail.scrollLeft = left;
    window.requestAnimationFrame(function () {
      rail.style.scrollSnapType = snap || '';
    });
  }

  // Which child sits nearest the middle of the rail right now.
  function nearestCell(rail) {
    var kids = rail.children;
    var middle = rail.scrollLeft + rail.clientWidth / 2;
    var best = 0;
    var bestGap = Infinity;
    for (var i = 0; i < kids.length; i++) {
      var gap = Math.abs(kids[i].offsetLeft + kids[i].offsetWidth / 2 - middle);
      if (gap < bestGap) { bestGap = gap; best = i; }
    }
    return best;
  }

  function initDots() {
    var rails = document.querySelectorAll('[data-gf-dots-rail]');

    for (var i = 0; i < rails.length; i++) {
      (function (rail) {
        var section = rail.closest('.shopify-section') || rail.parentNode;
        var wrap = section.querySelector('[data-gf-dots]');
        if (!wrap || wrap.childElementCount) return;

        var slides = realCards(rail);
        if (slides.length < 2) return;

        // Whether the rail overflows is not settled at this point, because the
        // cards are still being laid out and their images still loading, so the
        // loop is attempted again once the page has finished.
        var looped = false;

        function attemptLoop() {
          if (looped || !buildLoop(rail)) return;
          looped = true;
          slides = realCards(rail);
          jumpTo(rail, slides[0]);
        }

        attemptLoop();

        // Each section names its own dot class so one helper can drive them all.
        var dotClass = wrap.getAttribute('data-gf-dot-class') || 'gf-icons__dot';

        var dots = [];
        for (var j = 0; j < slides.length; j++) {
          (function (index) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = dotClass + (index === 0 ? ' is-active' : '');
            dot.setAttribute('aria-label', 'Go to item ' + (index + 1));
            dot.addEventListener('click', function () {
              if (looped) {
                centreOn(rail, slides[index]);
              } else {
                var delta = slides[index].getBoundingClientRect().left - rail.getBoundingClientRect().left;
                rail.scrollBy({ left: delta, behavior: 'smooth' });
              }
            });
            wrap.appendChild(dot);
            dots.push(dot);
          })(j);
        }

        // The rail holds three copies of the set, so a cell stands for the real
        // card at the same place in whichever copy it belongs to.
        function realIndex(cell) {
          return looped ? cell % slides.length : cell;
        }

        // Anything outside the middle copy is a stand in and needs stepping back.
        function strayed(cell) {
          return looped && (cell < slides.length || cell >= slides.length * 2);
        }

        function paint(active) {
          for (var d = 0; d < dots.length; d++) {
            dots[d].classList.toggle('is-active', d === active);
          }
        }

        var ticking = false;
        var settling = null;

        // Only step across once the rail has genuinely stopped. Moving it while
        // a swipe is still carrying pulls the card out from under the finger.
        function settle() {
          if (!looped) return;
          var cell = nearestCell(rail);
          if (!strayed(cell)) return;
          jumpTo(rail, slides[realIndex(cell)]);
        }

        rail.addEventListener('scroll', function () {
          if (!ticking) {
            ticking = true;
            window.requestAnimationFrame(function () {
              ticking = false;
              paint(realIndex(nearestCell(rail)));
            });
          }

          // Newer browsers say when scrolling has finished. The timer is kept
          // either way, at a length that outlasts the momentum of a flick, so a
          // browser that misses the event cannot leave the rail on a copy.
          window.clearTimeout(settling);
          settling = window.setTimeout(settle, 320);
        });

        if ('onscrollend' in window) rail.addEventListener('scrollend', settle);

        window.addEventListener('load', attemptLoop);
        window.addEventListener('resize', attemptLoop);
      })(rails[i]);
    }
  }



  // The drawer's close button. Left to the theme it would only run the sub menu
  // close, which hides the panel but leaves the page locked behind it, so this
  // takes the click first and runs the real close instead.
  function closeMenuDrawer(event) {
    var button = event.target.closest && event.target.closest('.gf-mnav__close');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    var drawer = button.closest('header-drawer');
    var summary = drawer && drawer.querySelector('summary.header__icon--menu');
    if (!drawer || !summary || typeof drawer.closeMenuDrawer !== 'function') return;
    drawer.closeMenuDrawer(event, summary);
  }

  function init() {
    var heroes = document.querySelectorAll('[data-gf-hero]');
    for (var i = 0; i < heroes.length; i++) initHero(heroes[i]);

    var bars = document.querySelectorAll('[data-gf-rotator]');
    for (var j = 0; j < bars.length; j++) initRotator(bars[j]);

    initHoverMenus();
    initRails();
    initDots();
    syncDisclosures();
    window.addEventListener('resize', syncDisclosures);

    document.removeEventListener('click', closeMenuDrawer, true);
    document.addEventListener('click', closeMenuDrawer, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The theme editor tears sections down and rebuilds them, so rebind after.
  document.addEventListener('shopify:section:load', init);
})();
